'use strict';

import clients from '../data/clients.js';
import clientsFr from '../data/clients-fr.js';

class Slider {
  constructor() {
    this.lang = document.querySelector('html').getAttribute('lang');
    console.log('here');
    this.defaultClientList = document.getElementById('client-list');
    if (this.defaultClientList) {
      this.removeDefaultClientList();
    }

    this.clientSlider = document.querySelector('#slider');
    if (this.clientSlider) {
      this.populateSlider();
    }
  }

  // methods
  slideBlockHTML(clientA, clientB, clientC, clientD) {
    this.clientSlider.insertAdjacentHTML(
      'beforeend',
      `
      <div class="slide-block">
        ${createSlide(clientA)}
        ${createSlide(clientB)}
        ${createSlide(clientC)}
        ${createSlide(clientD)}
      </div>
    `
    );

    function createSlide(client) {
      return `<div tabindex='0'><span>${client}</span></div>`;
    }
  }

  populateSlider() {
    var clientsList = this.lang === 'fr' ? clientsFr : clients;
    var numOfBlocks = clients.length / 4;
    var i;
    for (i = 1; i <= numOfBlocks; i++) {
      this.slideBlockHTML(
        clientsList[0],
        clientsList[1],
        clientsList[2],
        clientsList[3]
      );

      clientsList.splice(0, 4);
    }

    this.initSlider();
  }

  initSlider() {
    $(this.clientSlider).slick({
      prevArrow:
        '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="fas fa-angle-left"></i></button>',
      nextArrow:
        '<button class="slick-next slick-arrow" aria-label="Previous" type="button" style=""><i class="fas fa-angle-right"></i></button>',
      centerMode: false,
      arrows: true,
      autoplay: true,
      slidesToShow: 1,
      rows: 3,
      responsive: [
        {
          breakpoint: 700,
          settings: {
            rows: 1
          }
        }
      ]
    });
  }

  removeDefaultClientList() {
    this.defaultClientList.hidden = true;
  }
}

export default Slider;
